module.exports = __webpack_public_path__ + "img/dowanios.eef4d0b.png";